import { EAction } from '~/src/features/tariffBuilder/constants/actions';
import { IAction } from '~/src/store';

const setLoading = (state: boolean): IAction<EAction.Loading, { state: boolean }> => ({
    type: EAction.Loading,
    payload: {
        state,
    },
});

export default setLoading;
